import React from "react";
import { debugLog } from "../../util/debug";
import * as microsoftTeams from "@microsoft/teams-js";


function getQueryStringParameters(qs) {
    let hashParams = {};
    debugLog(qs);
    qs.substr(1)
        .split("&")
        .forEach(function (item) {
            let s = item.split("="),
                k = s[0],
                v = s[1] && decodeURIComponent(s[1]);
            hashParams[k] = v;
        });
    return hashParams;
}

export default function AuthEnd() {

    React.useEffect(() => {
        debugLog('Auth End - useEffect -- calling initialize')
 
        microsoftTeams.app.initialize().then(() => {
            debugLog('inside initalize')
            
            // note: window.location.search is empty if using a hash format, which is why we are using .hash here.
            const qsMap = getQueryStringParameters(window.location.hash.replace("#/maritz-sso", ''));
            const jwt = qsMap['jwt']

            if (!!jwt && jwt.length > 0) {
                microsoftTeams.authentication.notifySuccess({
                    jwt
                });
            } else {
                microsoftTeams.authentication.notifyFailure(JSON.stringify({
                    "error": "Unexpected Failure",
                    "payload": qsMap}));
            }
        });
        
    }, [])
    return (
        <div></div>
    )
}